<template>
  <MenuCard title="Capture" tooltip="Use Capture to capture the animation!">
    <v-card-text>
    <Row title="Animation">
      <v-select class="" hide-details :items="animations" v-model="currentAnimationName" dense outlined></v-select>
    </Row>

      <div>
        <Row title="Animation Duration">
          <p class="ma-0 pa-0 pb-1"> {{ currentAnimationDuration.toFixed(3) }} seconds</p>
        </Row>
        <Row title="Time between frames">
          <p class="ma-0 pa-0 pb-1"> {{ timeBetweenFrames.toFixed(3) }} seconds</p>
        </Row>
        <Row title="Number of Frames">
          <NumberController v-model="numberOfFrames" precision=0></NumberController>
        </Row>
        <Row title="Current Frame">
          <v-slider class="pt-3 pb-0 my-0" hide-details v-model.number:value="currentFrame" :min=1 :max="numberOfFrames" thumb-size=24 thumb-label="always"></v-slider>
        </Row>
        <Row title="Controls">
           <v-btn icon @click="togglePlayAnimation">
               <v-icon>{{'mdi-play-pause'}}</v-icon>
           </v-btn>
           <v-btn icon @click="stopAnimation">
               <v-icon>{{'mdi-stop'}}</v-icon>
           </v-btn>
        </Row>
        <Row title="Preview Time Between Frames">
          <NumberController v-model="previewTimeBetweenFrames" precision=0 step=10></NumberController>
        </Row>
        <Row title="Capture Width">
          <NumberController v-model="captureWidth" precision=0 step=100></NumberController>
        </Row>
        <Row title="Capture Height">
          <NumberController v-model="captureHeight" precision=0 step=100></NumberController>
        </Row>
        <Row title="Hide/Show Capture">
          <v-switch class="ma-0" v-model.number:value="isCaptureVisible"></v-switch>
        </Row>
        <Row title="Capture Normals">
          <v-switch class="ma-0" v-model.number:value="isCaptureNormals"></v-switch>
        </Row>
      <v-dialog v-model="dialog" max-width=70%>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" @click="captureAnimation" color="primary">Capture Animation
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
              Captured Images
          </v-card-title>

          <v-divider></v-divider>
          <v-divider></v-divider>

          <v-card-text>
          <!-- <v-row>
            <v-col cols=2>
              <v-img :src="gifDataUrl">
                  GIF
              </v-img>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col v-for="(dataUrl, index) in outputDataUrls" :key="index" cols=2>
              <v-img :src="dataUrl">
                  {{ index + 1}}
              </v-img>
            </v-col>
          </v-row>
          <v-row v-if="isCaptureNormals">
            <v-col v-for="(dataUrl, index) in outputDataUrlsNormals" :key="index" cols=2>
              <v-img :src="dataUrl">
                  {{ index + 1}}
              </v-img>
            </v-col>
          </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="downloadImagesAsZip"
            >
              Download Images
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </div>
    </v-card-text>
  </MenuCard>
</template>

<script>
import MenuCard from './MenuCard.vue';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import Row from './Row.vue';
import NumberController from './NumberController.vue';
//import Animated_GIF from 'animated_gif';
//var Animated_GIF = require('animated_gif');

  export default {
    name: 'CaptureMenu',
    components: {
        MenuCard,
        Row,
        NumberController,
    },
    methods: {
        setAnimation: function(animationName) {
            this.currentAnimationName = animationName;
        },
        togglePlayAnimation: function() {
            clearTimeout(this.currentTimeout);
            if (this.isPlayingAnimation) {
                this.isPlayingAnimation = false;
            } else {
                this.isPlayingAnimation = true;
                this.playOneFrame();
            }
        },
        stopAnimation: function() {
            clearTimeout(this.currentTimeout);
            this.isPlayingAnimation = false;
            this.currentFrame = 1;
            this.updateCurrentFrame(this.currentFrame);
        },
        playOneFrame: function() {
            if (this.isPlayingAnimation) {
                if (this.currentFrame < this.numberOfFrames) {
                    this.currentFrame += 1;
                } else {
                    this.currentFrame = 1;
                }
                this.currentTimeout = setTimeout(() => this.playOneFrame(), this.previewTimeBetweenFrames);
            }
        },
        captureAnimation: async function() {
            //console.log("Capture animation");
            this.isCapturing = true;
            this.stopAnimation();

            var hiddenCanvas = document.createElement('canvas');
            hiddenCanvas.width = this.captureWidth;
            hiddenCanvas.height = this.captureHeight;
            var hiddenContext = hiddenCanvas.getContext('2d');
            let startX = (this.renderer.domElement.width / 2.0) - (this.captureWidth / 2.0);
            let startY = (this.renderer.domElement.height / 2.0) - (this.captureHeight/ 2.0);

            this.outputDataUrls = [];
            this.outputDataUrlsNormals = [];
            //this.gifDataUrl = "";
            const sleepTimeToRender = m => new Promise(r => setTimeout(r, m))
            this.$store.commit("setIsShowNormals", false);
            var sleepTime = 100;
            await sleepTimeToRender(sleepTime);
            if (!this.isCapturing) { return;}
            for (let i = 1; i <= this.numberOfFrames; i++) {
                hiddenContext.clearRect(0, 0, hiddenCanvas.width, hiddenCanvas.height);
                this.updateCurrentFrame(i);
                await sleepTimeToRender(sleepTime);

                if (!this.isCapturing) { return;}
                hiddenContext.drawImage(this.renderer.domElement,
                                        startX, startY,
                                        this.captureWidth, this.captureHeight,
                                        0, 0,
                                        this.captureWidth, this.captureHeight);

                this.outputDataUrls.push(hiddenCanvas.toDataURL());
            }

            //Don't Capture Normals if we don't need to
            if (this.isCaptureNormals) {
                var currentEffect = this.$store.state.currentEffect;
                if (!this.isCapturing) { return;}
                this.$store.commit("setCurrentEffect", "No Effect");
                this.$store.commit("setIsShowNormals", true);
                await sleepTimeToRender(sleepTime);
                for (let i = 1; i <= this.numberOfFrames; i++) {
                    hiddenContext.clearRect(0, 0, hiddenCanvas.width, hiddenCanvas.height);
                    this.updateCurrentFrame(i);
                    await sleepTimeToRender(sleepTime);
                    if (!this.isCapturing) { 
                        this.$store.commit("setCurrentEffect", currentEffect);
                        this.$store.commit("setIsShowNormals", false);
                        return;
                    }

                    hiddenContext.drawImage(this.renderer.domElement,
                                            startX, startY,
                                            this.captureWidth, this.captureHeight,
                                            0, 0,
                                            this.captureWidth, this.captureHeight);

                    this.outputDataUrlsNormals.push(hiddenCanvas.toDataURL());
                }
                this.$store.commit("setCurrentEffect", currentEffect);
                this.$store.commit("setIsShowNormals", false);
                if (!this.isCapturing) { return;}
                await sleepTimeToRender(sleepTime);
            }

            // Remove the GIF code
            //var GIF = window.GIF;
            //var ag = new GIF({
            //    workerScript: '/assets/js/libs/gif.js/gif.worker.js',
            //    workers: 2,
            //    quality: 10,
            //    background: 'rgba(0, 0, 0, 0)',
            //    //dither: true,
            //    transparent: true,
            //});
            //for(let i = 0; i < this.outputDataUrls.length; i++) {
            //    let tmpImg = document.createElement('img');
            //    tmpImg.src = this.outputDataUrls[i];
            //    ag.addFrame(tmpImg, {delay: this.previewTimeBetweenFrames});
            //}

            //ag.on('finished', (blob) => {
            //    this.blobToDataURL(blob, (result) => {
            //        this.gifDataUrl = result;
            //    });
            //});

            //ag.render();
        },
        blobToDataURL: function(blob, callback) {
            var a = new FileReader();
            a.onload = function(e) {callback(e.target.result);}
            a.readAsDataURL(blob);
        },
        updateCurrentFrame: function(newFrame) {
            //console.log("Changing current frame");
            let frameInterval = this.currentAnimationDuration / this.numberOfFrames;
            let animationTime = (newFrame - 1)*frameInterval;
            this.$emit('setAnimationTime', animationTime);
        },
        downloadImagesAsZip: function() {
            var zip = new JSZip();
            var animationName = this.currentAnimationName;
            //console.log(animationName);
            var zipFilename = this.projectName + "_" + animationName + "_3dto2danimations.com.zip";
            zip.file("3dto2danimations.txt", "If you found the tool useful please share!");
            //var img = zip.folder("images");
            //img.file("smile.gif", "", {base64: true});

            var i = 0;
            var uri = null;
            var idx = null;
            var content = null;
            for (i = 0; i < this.outputDataUrls.length; i++) {
                uri = this.outputDataUrls[i];
                idx = uri.indexOf('base64,') + 'base64,'.length;
                content = uri.substring(idx);
                zip.file(animationName + "_" + i + ".png", content, {base64: true});
            }
            for (i = 0; i < this.outputDataUrlsNormals.length; i++) {
                uri = this.outputDataUrlsNormals[i];
                idx = uri.indexOf('base64,') + 'base64,'.length;
                content = uri.substring(idx);
                zip.file(animationName + "_normal_map_" + i + ".png", content, {base64: true});
            }

            //gif 
            //uri = this.gifDataUrl;
            //idx = uri.indexOf('base64,') + 'base64,'.length;
            //content = uri.substring(idx);
            //zip.file(animationName + ".gif", content, {base64: true});

            zip.generateAsync({type:"blob"})
            .then(function(content) {
                // see FileSaver.js
                saveAs(content, zipFilename);
            });
        },
    },
    
    mounted() {
    },

    data: function () {
        return { isPlayingAnimation: false, 
                 currentFrame: 1,
                 previewTimeBetweenFrames: 160,
                 dialog: false,
                 //gifDataUrl: "",
                 outputDataUrls: [],
                 outputDataUrlsNormals: [],
               };
    },

    props: ['projectName', 'animations', 'currentAnimationDuration', 'renderer'],
    watch: {
        dialog: function(value) {
            if (!value) {
                this.isCapturing = false;
            }
        },
        currentFrame: function(newFrame) {
            this.updateCurrentFrame(newFrame);
        },
        currentAnimationDuration: function(newDuration) {
            let value = parseInt(newDuration / 0.1)
            this.$store.commit('setNumberOfFrames', value);
        },
    },

    computed: {
        timeBetweenFrames: function() {
            return this.currentAnimationDuration / this.numberOfFrames;
        },
        numberOfFrames: {
            get() {
                return this.$store.state.numberOfFrames;
            },
            set(value) {
                this.$store.commit('setNumberOfFrames', value);
            },
        },
        captureWidth: {
            get() {
                return this.$store.state.captureWidth;
            },
            set(value) {
                this.$store.commit('setCaptureWidth', value);
            },
        },
        captureHeight: {
            get() {
                return this.$store.state.captureHeight;
            },
            set(value) {
                this.$store.commit('setCaptureHeight', value);
            },
        },
        isCaptureVisible: {
            get() {
                return this.$store.state.isCaptureVisible;
            },
            set(value) {
                this.$store.commit('setIsCaptureVisible', value);
            },
        },
        isCaptureNormals: {
            get() {
                return this.$store.state.isCaptureNormals;
            },
            set(value) {
                this.$store.commit('setIsCaptureNormals', value);
            },
        },
        currentAnimationName: {
            get() {
                return this.$store.state.currentAnimationName;
            },
            set(value) {
                this.$store.commit('setCurrentAnimationName', value);
            },
        },
    },
  }
</script>

